export default __webpack_public_path__ + "static/media/a009-ransomware-04.c0549fb1.svg";